import { createFileRoute } from "@tanstack/react-router";
import { legacyRedirectTo } from "@/lib/legacy-redirect";

// Legacy URL /routes → redirect to /app/routes.
export const Route = createFileRoute("/routes/")({
  beforeLoad: legacyRedirectTo("/app/routes"),
  component: () => null,
});
